import "./Resources.module.css";
import Header from "@/reusable_sections/Header";
import UrbanStories from "./sections/UrbanStories";
import JoinThe1220Family from "./sections/JoinThe1220Family";
import Footer from "@/reusable_sections/Footer";
export default function ResourcesPage() {
  return <div>
      <Header />
      <UrbanStories />
      <JoinThe1220Family />
      <Footer />
    </div>;
}